(function () {
  function Prescription() {
    // state of the prescription UI
    this.selection = {};

    this.uiShown = false;

    this.locale = null;

    this.lensVariantId = null;

    // used constants
    this.constants = Object.assign({}, window.PRESCRIPTION_CONSTANTS);
    console.log(Object.assign({}, window.PRESCRIPTION_CONSTANTS), 'Object');
    console.log(this.constants , 'this.constants')
    // because of history: varifocals needs to be lower case here
    // @see prescription-input.liquid -> <input name="glasses_type"> and there label_key
    this.constants.VARIFOCALS = 'varifocals';
    this.constants.SINGLE_VISION = 'single_vision';
    this.constants == Object.freeze(this.constants);

    // css selectors
    this.classes = {
      PRESCRIPTION_ROW: 'prescription__row',
      UNAVAILABLE: 'prescription__row--unavailable',
      PUPILLARY_DEPENDENT: {
        PUPILLARY_DEPENDENT: 'pupillary-distance-dependent',
        KNOWN: {
          SINGLE: 'pupillary-distance-dependent--known-single',
          DUAL: 'pupillary-distance-dependent--known-dual',
        },
        UNKNOWN: 'pupillary-distance-dependent--unknown',
        DISABLED: 'pupillary-distance-dependent--disabled',
        VALUE_ELEMENT_CLASSES: ['popup-value-pupillary_distance1', 'popup-value-pupillary_distance0'],
      },
      VARIFOCAL: {
        DEPENDENT: 'varifocal-dependent',
      },
      DROPDOWN: {
        DROPDOWN: 'prescription__dropdown',
        POPUP: 'prescription__dropdown-popup',
        OPEN: 'prescription__dropdown-popup--open',
        ENTRY: 'popup__entry',
        ACTIVE: 'popup__entry--active',
      },
      FOLD: {
        FOLD: 'prescription__fold',
        OPEN: 'prescription__fold--open',
        CLOSED: 'prescription__fold--closed',
      },
    };

    this.colorSwatches = [];

    this.error = null;

    this.setup();
  }

  /**
   * Helper to clearly create css class selectors from their names
   * @param className string
   */
  Prescription.prototype.classSelector = function (className) {
    return '.' + className;
  };

  /**
   * Writes a value into the state
   * @param key string
   * @param value any
   * @param index number
   */
  Prescription.prototype.setSelection = function (key, value, index) {
    // if ((key === undefined, value === undefined, index === undefined)) {
    // console.warn(
    //   'There is an undefined value:',
    //   'key: ',
    //   key,
    //   'value: ',
    //   value,
    //   'index: ',
    //   index
    // );
    // }
    if (index !== undefined) {
      this.selection[key][index] = value;
    } else {
      this.selection[key] = value;
    }

    // figure out which Lens should be added to the glasses in the cart
    this.lensVariantId = this.matchSelectionToLensSKU();

    // translate key or fall back
    var variantIdKey = this.locale['lens_variant_id'] || 'lens_variant_id';

    // set variant ID
    this.selection[variantIdKey] = this.lensVariantId;

    // add current selection to the line item properties
    this.storeSelection(this.selection);
  };

  /**
   * Serialize the prescription parameters into the add to cart form
   * @param values JSON prescription parameters
   */
  Prescription.prototype.storeSelection = function (values) {
    // clean up before putting in the selection elements
    this.clearMetaInputs();

    if (values) {
      // get the keys of the current selection
      var keys = Object.keys(this.selection);
      // iterate through the selection
      for (var i = 0; i < keys.length; i++) {
        // thereby get the key name from the translation and the value
        key = keys[i];
        var value = this.selection[key];
        var name = this.locale[key] || key;

        // if the value is an array, it is left and right (for each eye one entry)
        if (Array.isArray(value)) {
          // add right eye value
         
           // add left eye value
           if (name == 'PD' )
           {
             if (value[this.constants.LEFT] == '0')
             {
              // this.addMetaInput(name + ', ' + '', 'Empty');
             }
             else
             {
               this.addMetaInput(name + ', ' + '', value[this.constants.LEFT]);
 
             }
            
 
           }
           else if (name == 'Pupillary Distance')
           {
             if (value[this.constants.LEFT] == '0' &&  value[this.constants.RIGHT] == '0')
             {
              // this.addMetaInput(name  + ', ' + this.locale.label.right , 'Empty');
               //this.addMetaInput(name  + ', ' + this.locale.label.left , 'Empty');
 
             }
             else
             {
               this.addMetaInput(name + ', ' + this.locale.label.right, value[this.constants.RIGHT]);
               this.addMetaInput(name + ', ' + this.locale.label.left, value[this.constants.LEFT]);
 
             }
           }
           else
           {
             this.addMetaInput(name + ', ' + this.locale.label.right, value[this.constants.RIGHT]);
             this.addMetaInput(name + ', ' + this.locale.label.left, value[this.constants.LEFT]);
 
           }
 
         }
        // if the value is not an array, it is a primitive
        else {
          this.addMetaInput(name, value);
        }
      }
    }
  };

  /**
   * Take the values of the current selection and try to match those to a lens.
   * Need: Color, Material, Lens Type
   */
  Prescription.prototype.matchSelectionToLensSKU = function () {
    var matrix = this.getLensMatrix();

    var selectedColor = this.selection.color || this.selection['Lens Color'];
    //console.log(selectedColor);
    var selectedLensType = this.selection.lens_type;
    var selectedMaterial = this.getCheckedMaterial();

    var prefix = matrix.prefix;
    var color = matrix.color[selectedColor] || 'N/A';
    var material = matrix.material[selectedMaterial] || 'N/A';
    var lensType = matrix.lens_type[selectedLensType] || 'N/A';
    var sku = [prefix, material, color, lensType].join(' ');

    var variantSkuMap = this.getLensVariants();
    var variantId = variantSkuMap[sku];

    return variantId;
  };

  /**
   * Removes all lenses from the cart.
   * @returns Promise.
   */
  Prescription.prototype.removeLensesFromCart = function () {
    var variantSkuMap = this.getLensVariants();
    var variantIds = Object.values(variantSkuMap);
    var updates = {};
    variantIds.map(function (id) {
      updates[id] = 0;
    });
    var payload = {
      updates: updates,
    };

    return new Promise(function (resolve, reject) {
      jQuery.post('/cart/update.js', payload, function (data, textStatus, xhr) {
        if (textStatus === 'success' || xhr.status === 200) {
          resolve();
        } else {
          var error = {
            data: data,
            textStatus: textStatus,
            request: xhr,
          };
          reject(error);
        }
      });
    });
  };

  /**
   * Adds the lens for the current selection to the cart (twice).
   * First it removes any lens that might be in the cart by POSTing and update, which
   * contains the IDs for ALL lenses and the quantity 0 for each. Thereby removing any lens that
   * could be in the cart.
   *
   * After that, if POSTs the new lens, if a match was found.
   * @returns Promise
   */
  Prescription.prototype.addLensesToCart = function () {
    // prep payload
    var addRequestPayload = {
      items: [
        {
          id: this.lensVariantId,
          quantity: 2,
        },
      ],
    };

    var asyncFunction = function (resolve, reject) {
      if (!this.lensVariantId) {
        console.warn('No matching lens was found');
        resolve();
        return;
      }
      jQuery.post('/cart/add.js', addRequestPayload, function (data, textStatus, xhr) {
        if (textStatus === 'success' || xhr.status === 200) {
          resolve();
        } else {
          var error = {
            data: data,
            textStatus: textStatus,
            xhr: xhr,
          };
          reject(error);
        }
      });
    }.bind(this);

    return new Promise(asyncFunction);
  };

  /**
   * Adds a hidden input to the form. One input per prescription property.
   * Replaces the value if the input is already present.
   * @param name string
   * @param value any
   */
  Prescription.prototype.addMetaInput = function (name, value) {
    if (name === undefined || value === undefined) {
      return;
    }

    var wrapper = document.getElementById('prescription-values');

    var id = name.split(' ').join('-');

    // get or create the hidden input
    var input = document.getElementById(id);
    if (!input) {
      input = document.createElement('input');
      input.id = id;
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      wrapper.appendChild(input);
    }

    if (input.id == 'PrescriptionImage')
    {
      input.type = 'file';
      input.accept = 'image/*' ;

    }

    if (input.id == 'Pupillary-Distance,-Right-(OD)')
    {
      input.className = 'pd-right';

    }

    if (input.id == 'Pupillary-Distance,-Left-(OS)')
    {
      input.className = 'pd-left';

    }

    if (input.id == 'PD,-')
    {
      input.className = 'pd-left-right';

    }

    // replace true and false with translated yes and no
    if (value === true) {
      value = this.locale.yes;
    } else if (value === false) {
      value = this.locale.no;
    }

    input.value = value;
  };

  /**
   * Originally, the variation of the item is presented as one line of string, separated by "/" in the cart.
   * This should however be presented in a list type of view and prefixed. E.g. "color: green".
   * @see theme.js:1259 or search for "if( window.prescription)" therein.
   * @param item object
   * @returns object
   */
  Prescription.prototype.modifyLineItemProperties = function (item) {
   // debugger;
    // test if any one of the prescription line item properties is present.
    if (item.properties === null) {
      item.properties = {};
    }

    if (!!item.properties[this.locale['lens_type']]) {
      var variation = null;

      variation = item.variant_title.split(' / ');

      var frameAndLensColors = variation.reverse().pop().split('/');

      var frameColor = frameAndLensColors.pop();
      var lensColor = frameAndLensColors.pop();
      var lensType = variation.pop();
      var lensMaterial = variation.pop();

      item.properties[this.locale['frame_color']] = frameColor;
      item.properties[this.locale['lens_color']] = lensColor;
      item.properties[this.locale['lens_material']] = lensMaterial;
      item.properties[this.locale['lens_type']] = lensType;
    }
  };

  /**
   * Remove the inputs which hold prescription values
   */
  Prescription.prototype.clearMetaInputs = function () {
    var wrapper = document.getElementById('prescription-values');
    wrapper.innerHTML = '';
  };

  /**
   * Retrieves a value from the state
   * @param key string
   * @param index number
   */
  Prescription.prototype.getSelection = function (key, index) {
    if (index !== undefined) {
      index = parseInt(index);
      return this.selection[key][index];
    }
    return this.selection[key];
  };

  /**
   * Getter for the lens color ColoSwatches
   * @returns Array<ColorSwatch>
   */
  Prescription.prototype.getColorSwatches = function () {
    return this.colorSwatches;
  };

  /**
   * Selection of a basic glass type -> show additional fields and info dependent on the type
   * @param event MouseEvent
   */
  Prescription.prototype.onTypeSelected = function (event) {
    var dataset = event.target.dataset;
    var type = dataset.type;
    this.setSelection(this.constants.LENS_TYPE, type);

    switch (type) {
      case this.constants.SINGLE_VISION:
        {
          // reset the addition values
         // this.setSelection(this.constants.ADDITION, [0, 0]);

          // hide the extra inputs
          this.showVarifocalUi(false);

          // select the single vision product variant
          window.prescriptionVariantButtons.clickSingleVision();
        }
        break;
      case this.constants.VARIFOCALS:
        {
          // show the extra inputs
          this.showVarifocalUi(true);

          // select the varifocals product variant
          window.prescriptionVariantButtons.clickVarifocal();
        }
        break;
    }
    // triggering the color update inspects the variants and
    // marks the options available/unavailable
    this.triggerColorSwatch();

    if (window.innerWidth <= 768) {
      if (document.querySelector("#prescription-step-1") != null && !document.querySelector("#prescription-step-1").classList.contains("first-click")) {
        document.querySelector("#prescription-step-4").scrollIntoView();
      }
    }
  };

  /**
   * User selects a material radio in the prescription UI -> script should select
   * and click the appropriate button in the cart form
   * @param event MouseEvent
   */
  Prescription.prototype.onMaterialSelected = function (event) {
    var radio = event.target;
    // get material from radio
    var material = radio.dataset.type.replace('_', '+');
   // console.log(material ,'material');
    // fieldset class variant-input-wrap
    var selector = 'fieldset.variant-input-wrap input[type="radio"]';
    console.log(selector, 'selector');
    var variantButtonCandidates = Array.from(document.querySelectorAll(selector));
    var targetButtons = [];
    var iterator = function (button) {
      // input id contains serilium / material
      // filter out the material buttons
      var lowerId = button.id.toLowerCase();
      if (lowerId.indexOf('lens-material') > -1) {
        if (lowerId.indexOf(material) > -1) {
          targetButtons.push(button);
        }
      }
    };
    variantButtonCandidates.forEach(iterator.bind(this));
    if (targetButtons.length === 1) {
      targetButtons[0].click();
    } else {
      console.warn('There was more than one target found.');
    }

    // triggering the color update inspects the variants and
    // marks the options available/unavailable
    replace_material = material.replace('+', '');
    this.triggerColorSwatch();
    this.buildLensColorSelectors(replace_material);

    if (window.innerWidth <= 768) {
      if (document.querySelector("#prescription-step-1") != null && !document.querySelector("#prescription-step-1").classList.contains("first-click")) {
        document.querySelector("#prescription-step-2-1").scrollIntoView();
      }
    }
    const prescriptionRowGlassColor = document.getElementById('glass-color');
    const chooselensecolor = document.querySelector('#prescription__row_glass-color h3')
    prescriptionRowGlassColor.style.display = 'block';
    chooselensecolor.style.display = 'block';
  };

  /**
   * Set the pupillary distance values in the state and toggle classes for UI
   * @param event MouseEvent
   */
  Prescription.prototype.onPupillaryDistanceSelected = function (event) {
    var dataset = event.target.dataset;
    var type = dataset.type; // of known-single, known-dual, unknown

    this.setSelection(this.constants.PUPILLARY_DISTANCE_TYPE, type);

    // sync selection and activated PD UI part.
    this.syncPupillaryDistance(event);

    this.togglePupillaryDistanceUIState(type);

    this.resetPupillaryDistance(type);
  };

  /**
   * If the PD type is "UNKNOWN", then the values must be reset to zero.
   * @param type string
   * @param stateOnly boolean
   */
  Prescription.prototype.resetPupillaryDistance = function (type, stateOnly) {
    if (type === this.constants.UNKNOWN) {
      // reset the data
      this.setSelection(this.constants.PUPILLARY_DISTANCE, [0, 0]);

      // if we only need to reset the state (without resetting the ui), exit here.
      if (stateOnly) return;

      // reset the UI
      var classes = this.classes.PUPILLARY_DEPENDENT.VALUE_ELEMENT_CLASSES;

      var iterator = function (className) {
        var elements = Array.from(document.querySelectorAll(this.classSelector(className)));
        if (elements.length) {
          elements.forEach(subIterator.bind(this));
        }
      };

      var subIterator = function (element) {
        element.innerText = this.constants.PUPILLARY_DISTANCE_RESET_VALUE;
      };

      classes.forEach(iterator.bind(this));
    }
  };

  /**
   * User can switch between single and dual values and select individual numbers for each.
   * if the user does enters a number, then switches the type, enters different values and switches back,
   * the UI shows the old value of the first selection. However, the actual selection object does still hold the
   * values from the second selection. Thus: When changing between the types, the state must be synced BEFORE the user
   * enters any new values.
   * @param event MouseEvent
   */
  Prescription.prototype.syncPupillaryDistance = function (event) {
    // 1. find the presently visible values in the UI
    // 2. set the value on the state

    var row = this.classes.PRESCRIPTION_ROW;
    var className = this.classes.DROPDOWN.DROPDOWN;
    var selector = this.classSelector(className);
    var element = event.target;

    // the event can be from several elements somewhere near the dropdown.
    // bubble up until the row is found, in which the dropdown lies.
    // then query back down to get all the dropdowns in the parent row.
    while (!element.classList.contains(row)) {
      element = element.parentElement;
    }
    var dropdowns = element.querySelectorAll(selector);

    var iterator = function (dropdown) {
      var dataset = dropdown.dataset;
      var index = parseInt(dataset.index);
      var key = dataset.key;
      var valueElement = dropdown.querySelector('span[class^=popup-value]');
      var presentedValue = valueElement.innerHTML;
     // this.setSelection(key, presentedValue, index);

      // if there is only one dropdown, he have the single-value scenario.
      // set both values (L/R) to the same value
      if (dropdowns.length === 1 && index === 0) {
       // this.setSelection(key, presentedValue, 1);
      }
    };

    dropdowns.forEach(iterator.bind(this));
  };

  /**
   * Enables and disables the Pupillary Distance UI Elements, depending on the
   * selected type.
   * @param type string type of the pupillary distance selection (known-single, known-dual, unknown)
   */
  Prescription.prototype.togglePupillaryDistanceUIState = function (type) {
    var on = [];
    var off = [];

    var PUPILLARY_DEPENDENT = this.classes.PUPILLARY_DEPENDENT;

    switch (type) {
      case this.constants.KNOWN_DUAL:
        {
          on.push(this.classSelector(PUPILLARY_DEPENDENT.KNOWN.DUAL));
          off.push(this.classSelector(PUPILLARY_DEPENDENT.KNOWN.SINGLE));
          // there is nothing to disable in the unknown-dependent box. Just leave it be,
          // it's only confusing otherwise.
          // off.push(this.classSelector(PUPILLARY_DEPENDENT.UNKNOWN));
        }
        break;
      case this.constants.KNOWN_SINGLE:
        {
          on.push(this.classSelector(PUPILLARY_DEPENDENT.KNOWN.SINGLE));
          off.push(this.classSelector(PUPILLARY_DEPENDENT.KNOWN.DUAL));
          // see above
          // off.push(this.classSelector(PUPILLARY_DEPENDENT.UNKNOWN));
        }
        break;
      case this.constants.UNKNOWN:
        {
          // see above
          // on.push(this.classSelector(PUPILLARY_DEPENDENT.UNKNOWN));
          off.push(this.classSelector(PUPILLARY_DEPENDENT.KNOWN.SINGLE));
          off.push(this.classSelector(PUPILLARY_DEPENDENT.KNOWN.DUAL));
        }
        break;
      // If there is an undefined value, we skip the operation
      default: {
        return;
      }
    }

    on.forEach(function (selector) {
      var element = document.querySelector(selector);
      var classList = element.classList;
      var className = PUPILLARY_DEPENDENT.DISABLED;
      if (classList.contains(className)) {
        classList.remove(className);
      }
    });

    off.forEach(function (selector) {
      var element = document.querySelector(selector);
      var classList = element.classList;
      var className = PUPILLARY_DEPENDENT.DISABLED;
      if (!classList.contains(className)) {
        classList.add(className);
      }
    });
  };

  /**
   * Show or hide every element that is varifocal dependent
   * @param show boolean
   */
  Prescription.prototype.showVarifocalUi = function (show) {
    var dependents = document.querySelectorAll(this.classSelector(this.classes.VARIFOCAL.DEPENDENT));
    if (window.innerWidth >= 769) {
      dependents.forEach(function (dependent) {
        dependent.style.display = show ? 'flex' : 'none';
      });
    }
  };

  /**
   * EventHandler to be fired upon clicks on a dropdown value
   * @param event MouseEvent
   */
  Prescription.prototype.onEntryClicked = function (event) {
    var dataset = event.target.dataset;

    try {
      this.setSelection(dataset.key, dataset.value, dataset.index);
    } catch (e) {
      this.error = e.message;
      console.warn(e);
    }
   // console.log(this.selection);

    var className = 'popup-value-' + dataset.key.toString() + dataset.index.toString();
    // display selected value in the dropdown selector
    var dropdowns = Array.from(document.querySelectorAll(this.classSelector(className)));

    // if this is a pupillary distance dropdown, we need to ensure the values are correctly synced
    if (dataset.key === this.constants.PUPILLARY_DISTANCE) {
      // syncing too early will re-sync the old value. The value in the DOM needs to be updated first
      // (after the click) and so we use a tiny delay to prevent old data from spilling into the cart.
      var timerFunction = function () {
        this.syncPupillaryDistance(event);
      };
      setTimeout(timerFunction.bind(this), 10);
    }
    /**
     * The code below is only relevant for the pupillary distance dropdowns.
     * For all the other dropdowns, the event will bubble until root has been passed
     * and then nothing will be executed.
     * @param dropdown DomElement
     */
    var lookupFunction = function (dropdown) {
      // check if dropdown is not within a disabled element
      var parent = dropdown;
      var doSearch = true;

      while (doSearch) {
        // bubble up
        parent = parent.parentElement;

        // check if conditions still apply
        doSearch =
          parent && // parent element exists
          !parent.classList.contains(this.classes.PUPILLARY_DEPENDENT.PUPILLARY_DEPENDENT); // stop when the first element with the correct class has been found
      }

      // set the value only, if the dropdowns parent is enabled and we have indeed a parent.
      if (parent) {
        if (!parent.classList.contains(this.classes.PUPILLARY_DEPENDENT.DISABLED)) {
          dropdown.innerHTML = dataset.value;
        }
      } else {
        dropdown.innerHTML = dataset.value;
      }
    };
    dropdowns.forEach(lookupFunction.bind(this));

    // show or hide the unit display
    this.handleDropdownUnitDisplay(event);
  };

  /**
   * Depending on the value that was selected in a dropdown, the unit
   * should be either visible or not.
   * For numbers (e.g. specific values) the unit should be visible.
   * For Strings, such as the initial "Plano", the unit should be hidden.
   */
  Prescription.prototype.handleDropdownUnitDisplay = function (event) {
    var dataset = event.target.dataset;
    var testValue = dataset.value; // either a float value or a NaN String, such as "Plano"

    // hide the dropdown unit if the value is not a float number
    var hideUnit = !isNaN(parseFloat(testValue));

    // find the related dropdown value display
    var className = this.classes.DROPDOWN.DROPDOWN;
    var element = event.target;
    while (!element.classList.contains(className)) {
      element = element.parentElement;
    }

    var unitElement = element.querySelector('span.popup-value-unit');
    unitElement.style.display = hideUnit ? 'inline' : 'none';
  };

  /**
   * Handles clicks anywhere in the document.
   * Should close all open popups when the click happened outside a popup.
   * @param event MouseEvent
   */
  Prescription.prototype.onDocumentClicked = function (event) {
    // don't close all dropdowns when the click was on another (ot the same) dropdown.
    if (event.target.classList.contains(this.classes.DROPDOWN.DROPDOWN)) {
      return;
    }
    this.closeAllPopups();
  };

  /**
   * Close all other dropdowns and then open the popup of the clicked dropdown
   * @param event MouseEvent
   */
  Prescription.prototype.onDropdownClicked = function (event) {
    var DROPDOWN = this.classes.DROPDOWN;

    this.closeAllPopups();
    var target = event.target;
    var popup = target.querySelector(this.classSelector(DROPDOWN.POPUP));
    if (popup) {
      popup.classList.add(DROPDOWN.OPEN);

      // highlight the option with the current value
      var parentDataset = popup.parentElement.dataset;
      var currentValue = this.selection[parentDataset.key][parentDataset.index];
      var entries = popup.querySelectorAll(this.classSelector(DROPDOWN.ENTRY));

      entries.forEach.bind(this)(function (entry) {
        var dataset = entry.dataset;
        if (parseFloat(dataset.value) == parseFloat(currentValue)) {
          entry.classList.add(DROPDOWN.ACTIVE);
        } else {
          entry.classList.remove(DROPDOWN.ACTIVE);
        }
      });
    }
  };

  /**
   * @see prescription-pass.liquid::PrescriptionPass.consumeHoverKey()
   * @param event MouseEvent
   */
  Prescription.prototype.onDropdownHover = function (event) {
    var dataset = event.target.dataset;
    window.pass.consumeHoverKey(dataset.key, dataset.index);
  };

  /**
   *  @see prescription-pass.liquid::PrescriptionPass.consumeHoverKey()
   */
  Prescription.prototype.onDropdownLeave = function () {
    window.pass.consumeHoverKey();
  };

  /**
   * Test if the click happened inside an element of an active dropdown.
   * If so, do nothing.
   * If not, close all open dropdowns.
   * @param event MouseEvent
   */
  Prescription.prototype.closeAllPopups = function (event) {
    var DROPDOWN = this.classes.DROPDOWN;
    // only if the click was not inside and element that is a currently open popup
    try {
      var target = event.target;
      if (target) {
        if (target.classList.contains(DROPDOWN.OPEN)) {
          return;
        }
        if (target.classList.contains(DROPDOWN.DROPDOWN)) {
          var children = target.children;
          children.forEach(function (child) {
            if (child && child.classList.contains(DROPDOWN.OPEN)) {
              return;
            }
          });
        }
      }
    } catch (e) {}

    var currentlyOpenPopups = Array.from(document.querySelectorAll(this.classSelector(DROPDOWN.OPEN)));

    var openClass = DROPDOWN.OPEN;
    currentlyOpenPopups.forEach(function (popup) {
      popup.classList.remove(openClass);
    });
  };

  /**
   * Open or close the folding area (details) when the prescription button is clicked
   */
  Prescription.prototype.toggleFold = function () {
    var FOLD = this.classes.FOLD;
    var cleanUpFold = this.cleanUpFold.bind(this);

    var folder = document.querySelector(this.classSelector(FOLD.FOLD));

    // --open is only there for a short time. When the div is open, then neither the --open nor --closed classes are applied.
    // --open only adds an arbitrary height so the animation can happen.
    var isOpen = !folder.classList.contains(FOLD.CLOSED);

    if (isOpen) {
      // should close
      // set arbitrary height
      folder.classList.add(FOLD.OPEN);

      // then add the closed class -> triggers the closing animation
      this.timeout(function () {
        folder.classList.add(FOLD.CLOSED);
        cleanUpFold(folder);
      }, 100);
    }
    // should open
    else {
      folder.classList.add(FOLD.OPEN);

      this.timeout(function () {
        folder.classList.remove(FOLD.CLOSED);
        cleanUpFold(folder);
      }, 100);
    }
    
    //IF 
    
    // selection of a glass material (radio button)
    //debugger;
    var materialRadios = Array.from(document.querySelectorAll('input[type="radio"].material_type'));
    var lowest_price = Number.POSITIVE_INFINITY;
    var lowest_price_element;
    materialRadios.forEach(function (radio) {
      var price_int = parseInt(radio.dataset.variantPrice);
      if ( price_int < lowest_price) {
      	lowest_price = price_int;
        lowest_price_element = radio;
      }
    });
    if (lowest_price_element && lowest_price_element.hasAttribute("id")) {
      setTimeout(function(){
      	lowest_price_element.setAttribute("checked", "checked");
        // Create a new 'change' event
        var event = new Event('click');
        // Dispatch it.
        lowest_price_element.dispatchEvent(event);
      }, 1000);
    }
  };

  /**
   * Waits to the animationDuration (css) and then removes the animation related classes from the element,
   * returning it to it's natural state.
   *
   * @param folder Element
   */
  Prescription.prototype.cleanUpFold = function (folder) {
    // clean up classList after animation duration
    var animationDuration = this.getFoldAnimationDuration(folder);
    var OPEN = this.classes.FOLD.OPEN;

    this.timeout(function () {
      folder.classList.remove(OPEN);
    }, animationDuration * 2);
  };

  /**
   * Read the computed style of a folding element and fetch the transition duration in milliseconds
   * @param folder Element
   * @returns number
   */
  Prescription.prototype.getFoldAnimationDuration = function (folder) {
    var transitionDuration = window.getComputedStyle(folder).transitionDuration;
    var seconds = parseFloat(transitionDuration);
    var milliseconds = seconds * 1000;
    return milliseconds;
  };

  /**
   * Convenience wrapper to the timeout function with proper cleanup.
   * @param callback Function
   * @param timer number milliseconds
   */
  Prescription.prototype.timeout = function (callback, timer) {
    var timeout = window.setTimeout(function () {
      window.clearTimeout(timeout);
      callback();
    }, timer);
  };

  /** 
   * Fetch the default variant and redirect the user.
   * This is necessary, because there may be disabled buttons, depending on the currently selected option combination.
   * So the user might be stuck, even though the desired variant (no lens, no prescription) exists.
   * Hence, we grab the variant ID of that variant and do a hard redirect.
   */
  Prescription.prototype.hideUI = function () {
    // get the default variant
    var defaultVariant = this.getDefaultVariant();
    console.log(defaultVariant , 'defaultVariant')

    // redirect
    var location = window.location.href;
    location = location.replace(/variant=[0-9]*/, 'variant=' + defaultVariant.id);
    window.location.replace(location);
  };

  /**
   * Toggle the prescription box
   */
  Prescription.prototype.handleShowPrescription = function (show) {
    var element = document.querySelector('.prescription');
    if (show) {
      element.style.display = 'flex';
    } else {
      element.style.display = 'none';
      // if the UI is going to be hidden, no prescription is selected anymore.
      // thus -> clear the hidden input
      this.storeSelection(null);

      // assign the next variant, that is identical in option1 and has neither lens nor prescription (options 2 and 3)
      this.assignPrescriptionLessSiblingVariant();
    }

    this.moveColorSwatches(show);

    // the add (or remove) button could be pressed repeatedly.
    // We don't want to toggle the fold if there is no actual change in the users selection
    if (this.uiShown != show) {
      window.prescription.toggleFold();
    }

    this.uiShown = show;
    
    var allVariants = this.getVariants();

    var visibleInputWrapperList = document.querySelectorAll('.variant-input-wrap');
    console.log(visibleInputWrapperList, 'visibleInputWrapperList');
    var visibleInputWrapper = Array.from(visibleInputWrapperList).filter(function (wrapper) {
      if (wrapper.dataset && wrapper.dataset.index === 'option1') {
        return true;
      }
    })[0];
    var finalInputList = visibleInputWrapper.querySelectorAll('.variant-input');

    [].forEach.call(finalInputList, function(div) {
      for (varv in allVariants)
      {
        if (allVariants[varv].option2 =='None' && allVariants[varv].option1 == div.getAttribute("data-value") && allVariants[varv].available == false)
        {
          
          div.style.display = "none";

        }
      }
    });
  };

  /**
   * Moves the color selector for the frame color into the prescription UI.
   * If the Swatches are already there, the are replaced to their original slot.
   * @param moveToPrescription boolean
   */
  Prescription.prototype.moveColorSwatches = function (moveToPrescription) {
   // debugger;
    var colorSelectorNode = document.querySelector('.variant-wrapper.color-variant');

    console.log(colorSelectorNode ,'colorSelectorNode')

    var parentClass = moveToPrescription ? '#prescription__frame-color' : '.product-single__form';

    var targetParent = document.querySelector(parentClass);
    targetParent.prepend(colorSelectorNode);
//console.log(targetParent);
   this.applyStyleToFrameColorSelector();
  };

  /**
   * Detect if the Color Swatches for the Frame/Color variant selection is currently a child node
   * of the product form or if it has been moved into the prescription UI.
   *
   * If it is a child of the prescription UI, the inner ring must be hidden and the Lens color
   * must be removed from the title.
   *
   * If it is in the product form, the original state has to be restored.
   */
  Prescription.prototype.applyStyleToFrameColorSelector = function () {
    
    // get the actual node
    var colorSelectorClass = '.variant-wrapper.color-variant';
    var colorSelectorNode = document.querySelector(colorSelectorClass);
    var label = colorSelectorNode.querySelector('span[id^=VariantColorLabel]');

    // test if it is in the product form or has been moved to the prescription UI
    var isEmbedded = document.getElementById('prescription__frame-color').querySelector(colorSelectorClass) ? true : false;

    var withinPrescriptionClass = 'within-prescription';

    // change the UI to split the frame/color combined selector independent frame and color selectors
    if (isEmbedded) {
      // css rule will hide the inner circle after this class has been applied
      colorSelectorNode.classList.add(withinPrescriptionClass);

      // store original text in data attribute
      var text = label.innerText;

      // modify the text -> remove "/" and the lens color (after the "/")
      if (text.indexOf('/') > -1) {
        var frameNameOnly = text.split('/')[0];
        label.dataset.originalText = text;
        label.innerText = frameNameOnly;
      }
    } else {
      // remove css rule to re-present the inner circle
      colorSelectorNode.classList.remove(withinPrescriptionClass);

      // restore the original text
      if (label.dataset.originalText) {
        label.innerText = label.dataset.originalText;
        delete label.dataset.originalText;
      }
    }
  };

  /**
   * Take the available colors and build or rebuild the
   * selectors based on the currently selected glass type
   */
  Prescription.prototype.buildLensColorSelectors = function (replace_material) {
    // assemble node references
    //console.log('buildLensColorSelectors 1046');
    //console.log(replace_material);
    var colorJsonDiv = document.querySelector('div[id^=GlassColorJSON]');
    if (colorJsonDiv != null )
    {
      var rawText = document.querySelector('div[id^=GlassColorJSON]').innerText;
      var selectors = document.getElementById('glass-color__selectors');
     // var replace_material = material.replace('+', '_');
      document.getElementById('glass-color__selectors').className = replace_material
      //console.log(selectors);
      var colorName = document.getElementById('glass-color__selected-color-name');
      colorName.className = replace_material; 
  
  
      // get data
      var data = JSON.parse(rawText);
      var selectedMaterial = this.getCheckedMaterial();
      var settings = data.filter(function (setting) {
        return setting.material === selectedMaterial;
      });
  
      // cancel if there are not settings available
      if (!settings.length) {
        var message = 'No colors match this material! Material: ' + selectedMaterial;
        //console.log(selectedMaterial);
        console.warn(message, JSON.parse(rawText));
        return;
      }
  
      // clean up old selectors
      selectors.innerHTML = '';
      colorName.innerHTML = '';
  
      var colors = settings[0].colors;
      
      //preselect the first color like based color
      
      var colorSelectorClass = '.variant-wrapper.color-variant';
      var colorSelectorNode = document.querySelector(colorSelectorClass);
      var label = colorSelectorNode.querySelector('span[id^=VariantColorLabel]');
      var text = label.getAttribute("data-original-text");
      if(this.selection['Frame Color']){
      if (text.indexOf('/') > -1) {
        var frameNameOnly = text.split('/')[0];
        label.dataset.originalText = text;
        label.innerText = frameNameOnly;
        }
      }
  
      var swatches = [];
      // add one selector for each color
      //console.log('prescritoin => buildLensColorSelectors colors:', colors);
      //console.log(window.prescriptionSettings);
      for (var i = 0; i < colors.length; i++) {
        //console.log('prescritoin => buildLensColorSelectors i:', i);
        
        var color = colors[i];
        var swatch = new ColorSwatch(color);
        swatches.push(swatch);
        selectors.appendChild(swatch.DOM);
        if (text.indexOf('/') > -1) {
          var frameNameOnly = text.split('/')[1];
        }
    
        if(color.label == frameNameOnly)
        {
          swatches[i].onClick();
        }
      }
  
     // swatches[0].onClick(); // preselect the first color
  
      this.colorSwatches = swatches;
    }
  };

  /**
   * Based on the JSON fields, which are provided by the theme, we can access
   * all of the available variants. By taking the current variant id from the
   * window.location.href, we can access all data of the current variant
   * and find the matching variant, which is of the same "option1" (or color)
   * but has "None" option2 (or Prescription).
   *
   * We then find the swatch that the user would click to select this variant
   * and click it through the script.
   */
  Prescription.prototype.assignPrescriptionLessSiblingVariant = function () {
    var defaultVariant = this.getDefaultVariant();

    // -- Now, to find the target variant swatch: --

    // get the .variant-input-wrap with data-index="option1"
    var visibleInputWrapperList = document.querySelectorAll('.variant-input-wrap');
    console.log(visibleInputWrapperList ,'visibleInputWrapperList')
    var visibleInputWrapper = Array.from(visibleInputWrapperList).filter(function (wrapper) {
      if (wrapper.dataset && wrapper.dataset.index === 'option1') {
        return true;
      }
    })[0];

    // get the correct input for the option1 selection
    var finalInputList = visibleInputWrapper.querySelectorAll('.variant-input');
    var finalInput = Array.from(finalInputList).filter(function (input) {
      if (input.dataset && input.dataset.value === defaultVariant.option1) {
        return true;
      }
    })[0];

    // grab the variant id, put in the URL and redirect
    if (finalInput) {
      // finally, click the swatch, in case we found one.
      if (!finalInput.querySelector('input').disabled) {
        finalInput.click();
      }
    }
  };

  /**
   * Based on the window.location query parameter "variant", we figure out the current variant
   * and the the one that has the same option1, but "none" for options 2 and 3.
   * @returns any
   */
  Prescription.prototype.getDefaultVariant = function () {
   //debugger;
    // get all available variants from the theme's VariantsJson Element
    var allVariants = this.getVariants();
console.log(allVariants ,'allVariants')
    // get the currently selected variant from the window url
    var currentVariantID = window.location.href.split('variant=')[1];

    currentVariantID = parseInt(currentVariantID);

    // get the json object for the currently selected variant
    var currentVariant = allVariants.filter(function (variant) {
      return variant.id === currentVariantID;
    })[0];

    var filterFunction = function (variant) {
      // stop if old/basic variant is not the same (e.g. SatinBlack/ Graphite)
      if (currentVariant.option1 !== variant.option1) {
        return false;
      }

      if (variant.option2 !== this.constants.NO_PRESCRIPTION) {
        return false;
      }

      if (variant.option3 !== this.constants.NO_LENS) {
        return false;
      }

      // all checks passed, this is the wanted variant!
      return true;
    };

    // find the object that has the same option1 (i.e. color) and "None" for option2 and option3 (i.e. prescription)
    var defaultVariant = allVariants.filter(filterFunction.bind(this))[0];
    if (!defaultVariant) {
      defaultVariant = allVariants[0];
      console.log('Fall back to default product variant, as there is no match.');
    }

    return defaultVariant;
  };

  /**
   * Get the Single Vision option radio button and click it
   */
  Prescription.prototype.preselectSingleVision = function () {
    var radio = document.getElementById('glasses_type_single_vision');
    if (radio) {
      radio.click();
    } else {
      console.warn('Single Vision does not exist for this product, preselect ist not possible');
    }
  };

      /**
   * Get the PD option radio button and click it
   */ 
       Prescription.prototype.preselectPD = function () {
        //debugger;
       
        var radio = document.getElementById('pupillary-pupillary_distance_known-single');
       // var radio = document.getElementById('pupillary_distance_one');
        this.setSelection("pupillary_distance_one", [50, 0]);
      
        if (radio) {
          radio.click();
        } else {
          console.warn('PD not select');
        }
      };

  /**
   * Secondary Add To Cart Button.
   * This button is outside of the form and must virtual-click the actual
   * add to cart button that is within the form
   */
  Prescription.prototype.onAddToCartClicked = function () {
    var clickAddButtonFunction = function () {
      var allSubmitButtons = document.querySelectorAll('button[type=submit]');
      allSubmitButtons.forEach(function (button) {
        if (button.id.indexOf('AddToCart') > -1) {
          button.click();
        }
      });
    };

    var handleErrorFunction = function (error) {
      console.warn('add to cart error', error);
    };

    if (this.isValid()) {
      this.addLensesToCart().then(clickAddButtonFunction).catch(handleErrorFunction);
    }
  };

  /**
   * Form Validation
   * @returns boolean
   */
  Prescription.prototype.isValid = function () {
    // make sure the TOS-Agree checkbox is checked
    var valid = true;

    var checkboxes = ['prescription__tos', 'prescription-fresh', 'prescription__confirmation'];
    var errorClass = 'field__message--error';

    var iterator = function (checkboxId) {
      var checkbox = document.getElementById(checkboxId);
      var label = checkbox.labels[0];
      var hint = null;
      // get optional hint element
      if (checkbox.dataset && checkbox.dataset.hintId) {
        hint = document.getElementById(checkbox.dataset.hintId);
      }

      if (checkbox.dataset.hintId === "prescription__tos-hint") {
        document.querySelector(".prescription__tos-hint_wrapper").style.display = "block";
      }

      // manage error decoration
      if (checkbox.checked) {
        label.classList.remove(errorClass);
      } else {
        label.classList.add(errorClass);
        valid = false;
      }

      // show the optional hint
      if (hint) {
        hint.style.display = checkbox.checked ? 'none' : 'block';
      }
    };
    checkboxes.forEach(iterator);

    // scroll to the first non-valid element
    if (!valid) {
      var element = document.querySelector('.' + errorClass);
      if (element) {
       // element.scrollIntoView();
      }
    }

    return valid;
  };

  /**
   *
   */
  Prescription.prototype.observeColorChanges = function () {
   // debugger;
    var selector = 'input[name="Frame Color/Lens Color"] + label, input[name="Color"] + label';
    var colorSwatches = Array.from(document.querySelectorAll(selector));

    var iterator = function (swatch) {
      swatch.addEventListener('click', this.onColorSwatchClicked.bind(this));
    };

    colorSwatches.forEach(iterator.bind(this));
  };

  /**
   * Call the click Event of the color selection, but give it
   * the color that is currently selected.
   * Fetching the checked attribute of the actual input does not work,
   * as the template does not update the attribute.
   * Doing it the "correct" way results in the wrong color being selected.
   */
  Prescription.prototype.triggerColorSwatch = function () {
    // reuse the previously stored color
    this.onColorSwatchClicked(null, this.selection.color);
  };

  /**
   * When the user selects a different color, the UI must check upon the available variants.
   * It assumes the material stays the same and uses this pre selection to check which lenses should be
   * marked as available or unavailable.
   *
   * It also checks in the other direction, to show which materials would be available, if the user stayed
   * with the current lens selection.
   *
   * If the function is called explicitly (not from an event) you can define the color
   * with the colorOverride parameter.
   *
   * @param event MouseEvent
   * @param colorOverride string
   */
  Prescription.prototype.onColorSwatchClicked = function (event, colorOverride) {

    this.applyStyleToFrameColorSelector();
    if (!event && !colorOverride) {
      return;
    }

    var color;
    if (!colorOverride) {
      // depending on whether the user or the script clicked the swatch, we need go a different path to the input element
      var input = event.target.parentElement.parentElement;
      color = input.dataset.value;

      // color not defined -> go one step less up
      if (!color) {
        input = event.target.parentElement;
        color = input.dataset.value;
      }

      // only use the frame color part
      color = color.split('/')[0];
      // for Initial Cart value
       $("#Frame-Color").attr("value",color);

      // store the color selection so it can be used to update availability
      this.selection[this.locale['frame_color']] = color;
    } else {
      color = colorOverride;
    }

    /**
     * Filter Function which uses a variants option as haystack and the match parameter as needle.
     * Should be called by Array.filter.
     * @param optionName of this.constants.OPTION
     * @param match string
     * @param variant Object
     */
    var variantsFilter = function (optionName, match, variant) {
      if (!optionName || !match || !variant) {
        return false;
      }
      var lowerOption = variant[optionName].toLowerCase().split(' ').join('_');
      var lowerMatch = match.toLowerCase().split(' ').join('_');
      return lowerOption === lowerMatch;
    };

    /**
     * Loops over a list of radio buttons.
     * Checks if the row should be enabled or disabled by looking up the variant
     * for the row and checking the .available parameter.
     *
     * Lookup is done by providing a compareList, which should be a pre-filtered
     * Array that contains only the objects that are relevant for the lookup.
     * @param optionName string of this.constants.OPTION
     * @param compareList Array<Variant>
     * @param radio Input<Radio>
     */
    var rowIterator = function (optionName, compareList, radio) {
      var row = radio.parentElement;
      var typeOfRow = radio.dataset.type;
      var variantForRow = compareList.filter(variantsFilter.bind(this, optionName, typeOfRow));
      if (variantForRow.length === 1) {
        variantForRow = variantForRow[0];

        if (variantForRow.available) {
          row.classList.remove(this.classes.UNAVAILABLE);
        } else {
          row.classList.add(this.classes.UNAVAILABLE);
        }
      }
    };

    // get che currently checked radios
    var variants = this.getVariants();
    var material = this.getCheckedMaterial();
    var lensType = this.getCheckedLensType();

    // shorthand the option constants
    var OPTIONS = this.constants.OPTIONS;
    console.log(this ,'this');
    console.log(this.constants ,'this.constants');
    console.log(OPTIONS ,'OPTIONS');

    // get all the radios for the individual options
    var lensTypeRadios = this.getLensTypeRadios();
    var lensMaterialRadios = this.getMaterialRadios();

    // get the variants that match the new color
    var variantsByColor = variants.filter(variantsFilter.bind(this, OPTIONS.COLOR, color));

    // filter the color-matched variants by lens type
    var variantsByColorAndLensType = variantsByColor.filter(variantsFilter.bind(this, OPTIONS.LENS_TYPE, lensType));

    // filter the color-matched variants by material
    var variantsByColorAndMaterial = variantsByColor.filter(variantsFilter.bind(this, OPTIONS.MATERIAL, material));

    // iterate the lens type radios and check availability against color and material
    lensTypeRadios.forEach(rowIterator.bind(this, OPTIONS.LENS_TYPE, variantsByColorAndMaterial));

    // iterate the lens type radios and check availability against lens type and color
    lensMaterialRadios.forEach(rowIterator.bind(this, OPTIONS.MATERIAL, variantsByColorAndLensType));

    this.applyStyleToFrameColorSelector();
    if (window.innerWidth <= 768) {
      if (document.querySelector("#prescription-step-1") != null && !document.querySelector("#prescription-step-1").classList.contains("first-click")) {
        document.querySelector("#prescription-step-2").scrollIntoView();
      }
    }
  };

  /**
   * Returns the dataset.type value of the currently checked radio
   * for the lens material.
   * @returns string
   */
  Prescription.prototype.getCheckedMaterial = function () {
    var nodeList = this.getMaterialRadios();
    return this.getTypeOfRadio(nodeList);
  };

  /**
   * Returns the dataset.type value of the currently checked radio
   * for the lens type
   * @returns string
   */
  Prescription.prototype.getCheckedLensType = function () {
    var lensTypeRadios = this.getLensTypeRadios();
    return this.getTypeOfRadio(lensTypeRadios);
  };

  /**
   * Filters the node list inputs by their checked status.
   * If there is only one checked radio, it's dataset.type is going to be returned.
   * @param nodeList NodeList<Input<Radio>>
   */
  Prescription.prototype.getTypeOfRadio = function (nodeList) {
    var checkedRadios = this.getCheckedRadiosOfList(nodeList);
    if (checkedRadios.length === 1) {
      var radio = checkedRadios[0];
      return radio.dataset.type;
    } else {
      if (checkedRadios.length === 0) {
        return null;
      } else {
        throw 'Multiple radio buttons found, operation does not make sense.';
      }
    }
  };

  /**
   * Returns an Array of Inputs, which contains all radios for the lens type
   * @returns Array<Input<Radio>>
   */
  Prescription.prototype.getLensTypeRadios = function () {
    var selector = '#lens-type-selection input[name=glasses_type]';
    var nodeList = document.querySelectorAll(selector);
    return nodeList;
  };

  /**
   * Returns an Array of Inputs, which contains all radios for the lens material
   * @returns Array<Input<Radio>>
   */
  Prescription.prototype.getMaterialRadios = function () {
    var selector = '#glass-material-selection input[name=material]';
    var nodeList = document.querySelectorAll(selector);
    return nodeList;
  };

  /**
   * Filters an Array of radio buttons by their checked status.
   * Only checked radios will be returned.
   * @param nodeList NodeList
   * @returns Array<input[type=radio]>
   */
  Prescription.prototype.getCheckedRadiosOfList = function (nodeList) {
    return Array.from(nodeList).filter(function (radio) {
      return radio.checked;
    });
  };

  /**
   * Grabs the Variants JSON from the template and returns it as JSON object
   */
  Prescription.prototype.getVariants = function () {
    return JSON.parse(document.querySelector('div[id^=VariantsJson]').innerText);
    console.log( document.querySelector('div[id^=VariantsJson]').innerText,'getVariants')
  };

  /**
   * Get the matrix which defines how lens SKU is created based
   * on the selected lens type, color and material.
   * @returns JSON Object
   */
  Prescription.prototype.getLensMatrix = function () {
    var selector = 'div[id^=LensSKUsJson]';
    var container = document.querySelector(selector);
    if (container) {
      var rawJson = container.innerText;
      if (rawJson) {
        var json = JSON.parse(rawJson);
        if (json) {
          return json;
        }
      }
    }
    console.warn('Lens Matrix could not be parsed. Please check Element ' + selector);
    return {};
  };

  /**
   * Get the variant/sku map for the lens. This can then be searched by SKU
   * and the resulting variant id can be used to add it to the cart.
   * @returns JSON Object
   */
  Prescription.prototype.getLensVariants = function () {
    var raw = document.querySelector('div[id^=LensVariants]').innerText;
    if (raw) {
      // json is build up in liquid and may end with a comma before the closing brace.
      // since that is json invalid, json.parse would fail.
      // to prevent: replace ',}' with '}'
      var faultyEnd = ',}';
      var correctEnd = '}';
      if (raw.indexOf(faultyEnd)) {
        raw = raw.replace(faultyEnd, correctEnd);
      }
      var json = JSON.parse(raw);
      if (json) {
        return json;
      }
    }
    console.warn('Lens Variants could not be parsed. Please check Element ', selector);
    return {};
  };

  /**
   * Set up the initial selection.
   * @throws LocaleNotSetException
   */
  Prescription.prototype.initSelection = function () {
    if (!this.locale || !this.locale.plano) {
      throw 'LocaleNotSet';
    }

   /* if (document.getElementsByClassName('VariantFrameColorLabel')[0] != 'undefined')
    {
      var frameColor =  document.getElementsByClassName('VariantFrameColorLabel')[0].innerHTML;
      var frame_color = frameColor.split('/')[0] ;
    }*/

    var elements = document.getElementsByClassName('VariantFrameColorLabel');
    if (elements.length > 0) {
      var frameColor = elements[0].innerHTML;
      var frame_color = frameColor.split('/')[0];
    } else {
      console.log("Element with class 'VariantFrameColorLabel' was not found.");
    }


    var zero = this.locale.plano;
    this.selection = {
      /*sphere: [zero, zero],
      cylinder: [zero, zero],
      axis: [0, 0],
      addition: [0, 0],
      lens_type: null,
      pupillary_distance_type: '',
      pupillary_distance: [0, 0],
      color: null,*/

      sphereright: [null,zero],
      cylinderright: [null,zero],
      axisright: [null,0],
      additionright: [null,0],
      pupillary_distance_one: [0,null],
      pupillary_distance: [0, 0],
      sphereleft: [zero,null],
      cylinderleft: [zero,null],
      axisleft: [0,null],
      additionleft: [0,null],
      lens_type: null,
      pupillary_distance_type: '',
      frame_color: frame_color,
      color: null,
      PrescriptionImage: null,
    };
  };

  /**
   * Attach Event listeners
   */
  Prescription.prototype.setup = function () {

    setTimeout(() => {
      if (window.location.href.indexOf('&view=prescription') > -1)
      {
        document.getElementById("TogglePrescriptionOn").click();
      }
    }, "500")
    
    // assign the locale
    try {
      var localeElement = document.getElementById('prescription-locale');
      var data = JSON.parse(localeElement.innerText);
      this.locale = data;
    } catch (error) {
      console.warn('Prescription Setup Error', error);
    }

    this.initSelection();

    // click on dropdown entries
    var entries = Array.from(document.querySelectorAll(this.classSelector(this.classes.DROPDOWN.ENTRY)));

    var entriesClickFunction = this.onEntryClicked.bind(this);
    entries.forEach(function (entry) {
      if (entry.dataset && Object.keys(entry.dataset).length > 0) {
        entry.addEventListener('click', entriesClickFunction);
      }
    });

    // click on the dropdown select (to open the dropdown)
    var dropdowns = Array.from(document.querySelectorAll(this.classSelector(this.classes.DROPDOWN.DROPDOWN)));

    var dropdownClickFunction = this.onDropdownClicked.bind(this);
    var mouseOverFunction = this.onDropdownHover.bind(this);
    var mouseOutFunction = this.onDropdownLeave.bind(this);
    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('click', dropdownClickFunction);
      dropdown.addEventListener('mouseover', mouseOverFunction);
      dropdown.addEventListener('mouseout', mouseOutFunction);
    });

    // click anywhere else (closing the dropdown)
    var documentClickFunction = this.onDocumentClicked.bind(this);
    document.addEventListener('click', documentClickFunction);

    // selection of a glass type (radio button)
    var typeRadios = Array.from(document.querySelectorAll('input[type="radio"].lens_type'));
    var typeRadioSelectedFunction = this.onTypeSelected.bind(this);
    typeRadios.forEach(function (radio) {
      radio.addEventListener('click', typeRadioSelectedFunction);
    });

    // selection of a glass material (radio button)
    var materialRadios = Array.from(document.querySelectorAll('input[type="radio"].material_type'));
    var materialRadioSelectedFunction = this.onMaterialSelected.bind(this);
    materialRadios.forEach(function (radio) {
      radio.addEventListener('click', materialRadioSelectedFunction);
    });

    // selection of pupillary distance
    var pupillaryRadios = Array.from(document.querySelectorAll('input[type="radio"].pupillary-distance'));

    var pupillarySelectedFunction = this.onPupillaryDistanceSelected.bind(this);
    pupillaryRadios.forEach(function (radio) {
      radio.addEventListener('click', pupillarySelectedFunction);
    });

    // attach the second add-to-cart button
    var addToCartButton = document.querySelector('section.prescription__add-to-cart button');
    addToCartButton.addEventListener('click', this.onAddToCartClicked.bind(this));

    this.observeColorChanges();

    this.buildLensColorSelectors();
    
    //TODO if variant selected in location is presctipion open prescription box
    //TODO click on add prescription.
    // IF selected variant is a prescrtiption 
    //debugger;
    var allVariants = this.getVariants();
   
	
    // get the currently selected variant from the window url
    var currentVariantID = window.location.href.split('variant=')[1] ? window.location.href.split('variant=')[1] : "";

    currentVariantID = parseInt(currentVariantID);
    console.log(currentVariantID , 'currentVariantID');

    // get the json object for the currently selected variant
    var currentVariant = allVariants.filter(function (variant) {
      return variant.id === currentVariantID;
    })[0];

    /*if (currentVariant == undefined )
    {

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('variant', allVariants[0].id);
      window.location.search = urlParams;
      // var mylink = window.location.href + '?variant=' + allVariants[0].id ;
      //window.location.replace(mylink); 
      window.location.replace(mylink);
    }*/

        if (currentVariant === undefined) {
          const urlParams = new URLSearchParams(window.location.search);
          const firstVariantId = allVariants[0].id;
          console.log(allVariants[0], 'allVariants[0]');
      
          // Only update URL if the variant is different or not set
          if (urlParams.get('variant') !== firstVariantId && allVariants[0].available == true) {
            console.log('available')
              urlParams.set('variant', firstVariantId);
      
              // Update the URL without reloading the page
              window.history.pushState({}, '', `${window.location.pathname}?${urlParams}`);
          }
          else {
            console.log('not available')
            urlParams.set('variant', allVariants[0].id);
            window.location.search = urlParams;

          }
      }
    

    if(typeof currentVariant !== "undefined" && currentVariant.option2 !== "None") {
      //Select non prescription variant and reload
      // get the default variant
      var defaultVariant = this.getDefaultVariant();

      // redirect
      var location = window.location.href;
      location = location.replace(/variant=[0-9]*/, 'variant=' + defaultVariant.id);
      window.location.replace(location);
    } else {
      this.clearMetaInputs();
    }
   	
    
  };

  window.prescription = new Prescription();

  // add prescription calls to cart drawer
  // wait to add the decorator, until the drawer script has loaded
  setTimeout(function () {
    if (theme.CartDrawer) {
      return ;
      var originalFunction = theme.CartDrawer.prototype.buildCart;
      var decoratorFunction = function (cart, openDrawer) {
        // split the title into material and color info sections
        var items = cart.items;
        items.forEach(function (item) {
          if (item) {
            window.prescription.modifyLineItemProperties(item);
          }
        });

        window.prescription.applyStyleToFrameColorSelector();

        // call the original function, which will add the above modified .properties to the cart item
        originalFunction.call(this, cart, openDrawer);
      };
      theme.CartDrawer.prototype.buildCart = decoratorFunction;
    }
  }, 500);
})();

document.getElementById('pupillary-pupillary_distance_known-single').addEventListener('click', () => {
  $(".pd-right").removeAttr("value");
  $(".pd-left").removeAttr("value");
 })
 
 document.getElementById('pupillary-pupillary_distance_known-dual').addEventListener('click', () => {
   var dropdown_left = document.getElementById('pupillary_distance');
   var dropdown_left_val =  $('.popup__column.min').find("div.popup__entry[data-value='25.0']");
   
    if (dropdown_left) {
      dropdown_left.click();
      dropdown_left_val.click();
      //$('.popup__column min').val('25.5');
      $('.popup__column.min').find("div.popup__entry[data-index='1']");
     // $("#popup-value-pupillary_distance1").text("25");
    } else {
      console.warn('PD not select');
    }                                                                                   
   $(".pd-left-right").removeAttr("value");
  })
 
  document.getElementById('pupillary_distance_one').addEventListener('click', () => {
    $(".pd-right").removeAttr("value");
    $(".pd-left").removeAttr("value");
  })
 
  document.getElementById('pupillary-distance-unknown').addEventListener('click', () => {
  
   $(".pd-right").removeAttr("value");
   $(".pd-left").removeAttr("value");
   $(".pd-left-right").removeAttr("value");
 })
 
  document.getElementsByClassName('prescription__dropdown pupillary_distance')[0].addEventListener('click', () => {
  
   $(".pd-left-right").removeAttr("value");
 
 })
 
 document.getElementsByClassName('prescription__dropdown pupillary_distance')[1].addEventListener('click', () => {

   $(".pd-left-right").removeAttr("value");
 })

// Attempt to get the element with the specified ID
var prescriptionRowOpticalClear = document.getElementById('prescription__row_optical_clear');

// Check if the element exists
if (prescriptionRowOpticalClear !== null) {
  // If the element exists, add the event listener
  prescriptionRowOpticalClear.addEventListener('change', function() {
      // Get the necessary elements
  const lensColor = document.getElementById('Lens-Color');
  const prescriptionRowOpticalClear = document.getElementById('prescription__row_optical_clear');
  const prescriptionRowGlassColor = document.getElementById('glass-color');
  const chooselensecolor = document.querySelector('#prescription__row_glass-color h3');

  // Verify that all the elements exist
  if (prescriptionRowOpticalClear && prescriptionRowGlassColor && lensColor && chooselensecolor) {
    // Hide the 'prescription__row_glass-color' element
    prescriptionRowGlassColor.style.display = 'none';
    chooselensecolor.style.display = 'none';
    // Set the value of 'Lens-Color' to 'optical_Clear'
    lensColor.value = '';
  } else {
    console.error("One or more elements could not be found.");
  }
  });
} else {
  // If the element does not exist, log an error or handle it as needed
  console.log("Element with ID 'prescription__row_optical_clear' was not found.");
}

// Push a state to the history stack immediately after the page loads
document.addEventListener('DOMContentLoaded', (event) => {

  // Replace the current state
  history.replaceState({ myTag: true }, null, '');

  // Push a new dummy state right after
  history.pushState(null, null, '');
});

// Listen for the popstate event
window.addEventListener('popstate', function(event) {
  // If our custom state is at the history stack, we know the back button was pressed
  if (event.state && event.state.myTag && window.prescription) {
    // Call 'getDefaultVariant' on the 'prescription' instance
    var defaultVariant = window.prescription.getDefaultVariant();

    // Redirect to the default variant
    var location = window.location.href;
    console.log('location prescription.js');
    location = location.replace(/variant=\d+/, 'variant=' + defaultVariant.id);
    window.location.replace(location);
  }
});